import React, { memo, useEffect, useState } from 'react';
import { Autocomplete, ListItemText, MenuItem, TextField } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { AddBox } from '@mui/icons-material';
import AddTdsTcsOptions from '../../PrimeFigma/Modals/TcsTdsOptions/AddTdsTcsOptions';
import { grey } from '@mui/material/colors';
const CustomAutocomplete = React.forwardRef(
  ({ formik, name, options, label, viewPage, disabled, getAccountData, showRequired = false }, ref) => {
  const [openTdsTcsModal, setOpenTdsTcsModal] = useState(false);
  const [datatds, setDataTDS] = useState(null);
  const handleKeyDown = (e, fieldName) => {
    if (e.key === 'Tab' || e.key === 'Enter') {
      const fieldError = formik.errors[fieldName];
      const fieldTouched = formik.touched[fieldName];

      if (fieldError && fieldTouched) {
        e.stopPropagation();
        e.preventDefault(); // Prevent tab navigation if field has an error
      }
    }
  };
  useEffect(() => {
    if (datatds) {
      getAccountData();
      formik.setFieldValue('TDSPercentage', datatds?.tdsPercent);
      formik.setFieldValue('TDSSection', datatds?.tdsOptions);
    }
  }, [datatds]);
  const renderOption = (props, option) => (
    <>
      {option === 'Add New TDS Option' ? (
        <MenuItem
          value={'addTdsOption'}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            setOpenTdsTcsModal(true);
            setDataTDS('');
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            position: 'sticky',
            // bottom: "-7.5px",
            top: '0px',
            zIndex: 1,
            backgroundColor: grey[50],
            '&:hover': {
              backgroundColor: grey[200],
            },
          }}
        >
          <AddBox
            fontSize="small"
            sx={{
              marginRight: '5px',
              color: 'primary.main',
            }}
          />
          <ListItemText sx={{ color: 'primary.main' }} primary="Add New TDS Option" />
        </MenuItem>
      ) : (
        <li {...props}>{option.option}</li>
      )}
    </>
  );
  if (name === 'DistrictD') {
    console.log(options, 'options');
  }

  return (
    <>
      <Autocomplete
        // open={openState}
        // onClose={() => setOpenState(false)}
        id={name}
        size="small"
        disabled={viewPage || disabled}
        getOptionLabel={(option) =>
          name === 'TDSSection'
            ? option.option
            : name === 'pos'
            ? `(${option.statecode}) ${option.statename}`
            : name === 'DistrictD' || name === 'District'
            ? option?.label?.toLowerCase()?.replace(/\b\w/g, (char) => char.toUpperCase())
            : option.label
        }
        value={
          options?.find((option) =>
            name === 'TDSSection'
              ? option.section == formik.values[name]
              : name === 'billingCurrency'
              ? option.value == formik.values[name]
              : name === 'pos' || name === 'State' || name === 'StateD'
              ? option.statecode
                ? option.statecode == formik.values[name]
                : ''
              : name === 'District' || name === 'DistrictD'
              ? option?.id?.replace(/\s+/g, '').toLowerCase() === formik.values[name].replace(/\s+/g, '').toLowerCase()
              : option.id == formik.values[name]
          ) || null
        }
        onFocus={() => formik.setFieldTouched([name], true)}
        onBlur={() => formik.setFieldTouched([name], true)}
        onKeyDown={(e) => handleKeyDown(e, name)}
        onChange={(event, option) => {
          console.log(option, 'option');

          if (name === 'TDSSection') {
            formik.setFieldValue('TDSPercentage', option?.value);
            formik.setFieldValue('TDSSection', option?.section);
          } else if (name === 'pos') {
            formik.setFieldValue('pos', option ? option.statecode : '');
          } else if (name === 'State') {
            console.log(option, 'option');

            formik.setFieldValue('State', option.statecode ? option.statecode : '');
          } else if (name === 'StateD') {
            formik.setFieldValue('StateD', option ? option.statecode : '');
          } else if (name === 'Country' && option?.id !== 'IndiaState') {
            formik.setFieldValue('State', '');
            formik.setFieldValue('District', '');
            formik.setFieldValue('Pincode', '');
            formik.setFieldValue('City', '');
            formik.setFieldValue('billingAddress', '');
            if (option) {
              formik.setFieldValue('Country', option?.id);
            } else {
              formik.setFieldValue('Country', '');
              formik.formik.setFieldError([name], 'Please provide Country');
            }
          } else if (name === 'CountryD' && option?.id !== 'IndiaState') {
            formik.setFieldValue('StateD', '');
            formik.setFieldValue('DistrictD', '');
            formik.setFieldValue('PincodeD', '');
            formik.setFieldValue('CityD', '');
            formik.setFieldValue('billingAddressD', '');
            formik.setFieldValue('CountryD', option?.id);
            // setBool(false);
            if (option === null) {
              formik.setFieldValue([name], '');
              formik.formik.setFieldError([name], 'Please provide Country');
              formik.setFieldTouched([name], true);
            } else {
              formik.setFieldValue([name], option?.id);
            }
          } else if (name === 'billingCurrency') {
            formik.setFieldValue([name], option ? option.value : '');
          } else {
            formik.setFieldValue([name], option ? option.id : '');
          }
        }}
        options={name === 'TDSSection' ? ['Add New TDS Option', ...options] : options}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            sx={{
              '.MuiFormLabel-asterisk': {
                color: 'danger.main',
                fontSize: '20px',
                fontWeight: 'bold',
              },
            }}
            inputRef={ref}
            required={showRequired || (formik.errors[name] && !formik.values[name])}
            error={formik.touched[name] && formik.errors[name]}
            // InputProps={{
            //   ...params.InputProps,
            //   endAdornment: (
            //     <>
            //       {formik.errors[name] && !formik.values[name] && (
            //         <CheckIcon style={{ color: "red" }} />
            //       )}
            //       {params.InputProps.endAdornment}
            //     </>
            //   ),
            // }}
          />
        )}
        renderOption={name === 'TDSSection' ? renderOption : undefined}
      />
      {formik.touched[name] && formik.errors[name] ? (
        <p className="error" style={{ fontSize: '12px', padding: '0px' }}>
          {formik.errors[name]}
        </p>
      ) : (
        <p style={{ padding: '9px' }}></p>
      )}
      {openTdsTcsModal === true && (
        <AddTdsTcsOptions
          open={openTdsTcsModal}
          setOpen={setOpenTdsTcsModal}
          optionType={'Add New TDS Option'}
          setDataTDS={setDataTDS}
          getAccountData={getAccountData}
          Type="Party"
        />
      )}
    </>
  );
});

export default CustomAutocomplete;
